class HeaderScroll {
  constructor(headerElement) {
    this.header = headerElement;
    this.isCollections = this.header && this.header.classList.contains('header-collections-or-products');
    this.init();
  }
  

  init() {
    if (this.header) {
      window.addEventListener('scroll', () => this.toggleHeaderStyle(), { passive: true });
      this.toggleHeaderStyle();
    }
  }

  toggleHeaderStyle() {
    const scrolled = window.scrollY > 0;
    if (this.header) {
      this.header.classList.remove('nav-bar-dark', 'nav-bar-collections');
      
      if (scrolled) {
        if (this.isCollections) {
          this.header.classList.add('nav-bar-collections');
        } else {
          this.header.classList.add('nav-bar-dark');
        }
      }
    }
  }
}

class PhoneLink {
  constructor(phoneLink) {
    this.link = phoneLink;
    this.addRemarkableClass();
  }

  addRemarkableClass() {
    if (this.link) {
      this.link.classList.add('remarkable-phone');
    }
  }
}

class DropdownMenu {
  constructor(menuElement) {
    this.menu = menuElement;
    this.subMenu = this.menu.querySelector('.custom-dropdown-submenu');
    this.init();
  }

  init() {
    if (this.subMenu) {
      this.menu.addEventListener('mouseenter', () => this.toggleSubMenu(true));
      this.menu.addEventListener('mouseleave', () => this.toggleSubMenu(false));
    }
  }

  toggleSubMenu(isVisible) {
    if (this.subMenu) {
      this.subMenu.classList.toggle('active', isVisible);
    }
  }
}

class ContactFormToggle {
  constructor(contactForm) {
    this.toggleButton = document.querySelectorAll('.toggle-contact');
    this.contactForm = contactForm;
    this.init();
  }

  init() {
    this.toggleButton.forEach(button => {
      button.addEventListener('click', () => this.toggleForm());
    });
  }

  toggleForm() {
    const primaryButton = document.getElementById('toggle-contact');
    this.contactForm.toggleAttribute('open');
    this.contactForm.scrollIntoView({ behavior: 'smooth' });

    if (this.contactForm.hasAttribute('open')) {
      primaryButton.textContent = 'Close';
    } else {
      primaryButton.textContent = 'Contact';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const headerWrapper = document.querySelector('.header-wrapper');
  const menuItems = document.querySelectorAll('.custom-dropdown-items');
  const phoneLinksHeader = document.querySelectorAll(
    '.location-content a[href^="tel:"]'
  );
  const phoneLinksFooter = document.querySelectorAll(
    '.contact-location-separator a[href^="tel:"]'
  );
  const contactContainer = document.getElementById('onscreen-contact');

  menuItems.forEach((menu) => new DropdownMenu(menu));
  new HeaderScroll(headerWrapper);
  phoneLinksHeader.forEach((link) => new PhoneLink(link));
  phoneLinksFooter.forEach((link) => new PhoneLink(link));
  // new ContactFormToggle(contactContainer);
});